import React, { useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import CategoryItemListComponent from "../../components/CategoryItem/CategoryItemList";
import { useParams } from "react-router-dom";


export default function CategoryList() {
    const params = useParams();
    useEffect(() => {
        window.scrollTo(0, 0);
    })

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
                document.body.classList.remove("offcanvas-active");
            }}
        >
            <div>
                <div className="container-fluid">
                    <PageHeader
                        HeaderText="Category Items"
                        Breadcrumb={[
                            { name: "Categories", navigate: "/categories" },
                            { name: "Category View", navigate: `/categories/view/${params.categoryId}` },
                            { name: "Category Items", navigate: "" },
                        ]}
                    />
                    <div className="row clearfix">
                        <CategoryItemListComponent />
                    </div>
                </div>
            </div>
        </div>
    );
}
